/**
 * @fileoverview Legend in the footer of the student matrix, drawn with the same icon/color the teacher's
 * cells use (so the two profiles never drift).
 */

import { Box, Group, Text, ThemeIcon } from '@mantine/core'
import { useTranslation } from 'react-i18next'
import { STATUS_COLOR, STATUS_ICON } from 'pages/TaskTracker/components/TableCells'
import type { TrackStatus } from '../types'
import { StudentTrackerUploadMark } from './StudentTrackerUploadMark'

const LEGEND_STATUSES: TrackStatus[] = ['pending', 'in_progress', 'completed']
const ENTRY_SPACING = 'lg'
const ICON_LABEL_SPACING = 'xs'
const LEGEND_ICON_SIZE = 'md'

export function StudentTrackerLegend() {
  const { t } = useTranslation()

  return (
    <Group spacing={ENTRY_SPACING} role='list' aria-label={t('student_task_tracker.legend.title')}>
      {LEGEND_STATUSES.map(status => (
        <Group key={status} spacing={ICON_LABEL_SPACING} noWrap role='listitem'>
          <ThemeIcon variant='light' color={STATUS_COLOR[status]} size={LEGEND_ICON_SIZE} radius='sm'>
            {STATUS_ICON[status]}
          </ThemeIcon>
          <Text size='sm' color='dimmed'>
            {t(`student_task_tracker.legend.${status}`)}
          </Text>
        </Group>
      ))}
      <Group spacing={ICON_LABEL_SPACING} noWrap role='listitem'>
        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
          <ThemeIcon variant='light' color={STATUS_COLOR.completed} size={LEGEND_ICON_SIZE} radius='sm'>
            {STATUS_ICON.completed}
          </ThemeIcon>
          <StudentTrackerUploadMark />
        </Box>
        <Text size='sm' color='dimmed'>
          {t('student_task_tracker.legend.uploaded_by_teacher')}
        </Text>
      </Group>
    </Group>
  )
}
